function initYafkaiCarousels() {
  document.querySelectorAll('.yafkai-carousel').forEach(function(carousel) {
    if (carousel.dataset.initialized === 'true') return;

    var slides = carousel.querySelectorAll('.yafkai-slide');
    if (slides.length < 2) return;

    var idx = 0;

    function showSlide(n) {
      slides[idx].style.display = 'none';
      idx = (n + slides.length) % slides.length;
      slides[idx].style.display = 'block';
    }

    var prev = document.createElement('button');
    prev.className = 'yafkai-prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var next = document.createElement('button');
    next.className = 'yafkai-next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    carousel.appendChild(prev);
    carousel.appendChild(next);

    prev.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showSlide(idx - 1);
    });

    next.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showSlide(idx + 1);
    });

    carousel.dataset.initialized = 'true';
  });
}

document.addEventListener('DOMContentLoaded', initYafkaiCarousels);
document.addEventListener('shopify:section:load', initYafkaiCarousels);
